const holder = {
  closeDateRangeSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false });
      document.removeEventListener("mousedown", holder.closeDateRangeSelector);
    }
  },
};

export default {
  "MultiPrioritySelector.Selector": ({ isOpen, containerRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    internalStateSetter({ isOpen: !isOpen });
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeDateRangeSelector);
    } else {
      document.addEventListener("mousedown", holder.closeDateRangeSelector);
    }
  },
  "MultiPrioritySelector.Selector.PriorityWrapper.Selector": ({ isOpen, containerRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    internalStateSetter({ isOpen: !isOpen });
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeDateRangeSelector);
    } else {
      document.addEventListener("mousedown", holder.closeDateRangeSelector);
    }
  },
  "MultiPrioritySelector.Body.Option": ({ priority, selectedPriorities }, outlet, internalStateSetter) => {
    const newSelectedPriorities = [...selectedPriorities];
    const index = newSelectedPriorities.indexOf(priority.id);
    if (index === -1) {
      newSelectedPriorities.push(priority.id);
    } else {
      newSelectedPriorities.splice(index, 1);
    }
    internalStateSetter({ selectedPriorities: newSelectedPriorities, isOpen: false });
    outlet({ selectedPriorities: newSelectedPriorities });
  },
  "MultiPrioritySelector.Body.Option.Option": ({ priority, selectedPriorities }, outlet, internalStateSetter) => {
    const newSelectedPriorities = [...selectedPriorities];
    const index = newSelectedPriorities.indexOf(priority.level);
    if (index === -1) {
      newSelectedPriorities.push(priority.level);
    } else {
      newSelectedPriorities.splice(index, 1);
    }
    internalStateSetter({ selectedPriorities: newSelectedPriorities, isOpen: false });
    outlet({ selectedPriorities: newSelectedPriorities })
  },
  "MultiPrioritySelector.Body.ClearAllHeader.ClearAll": ({ selectedPriorities, priorities }, outlet, internalStateSetter) => {
    if (selectedPriorities.length > 0) {
      internalStateSetter({ selectedPriorities: [], isOpen: false });
      outlet({ selectedPriorities: [] });
    } else {
      internalStateSetter({ selectedPriorities: priorities.map(p => p.id), isOpen: false });
      outlet({ selectedPriorities: priorities.map(p => p.id) });
    }
  }
};
